import * as Base from "DistributedTaskControls/Common/Components/Base";
import * as Resources from "DistributedTaskControls/Resources/TFS.Resources.DistributedTaskControls";
import { IInputControlPropsBase, IInputControlStateBase, InputControlType } from "DistributedTaskControls/SharedControls/InputControls/Common";
import { ContributionComponent } from "DistributedTaskControls/SharedControls/InputControls/Components/ContributionComponent";
import { InputBase } from "DistributedTaskControls/SharedControls/InputControls/Components/InputComponentBase";
import { Component as RequiredIndicator } from "DistributedTaskControls/SharedControls/InputControls/Components/RequiredIndicator";
import * as React from "react";
import * as QueryControl from "TFS/WorkItemTracking/Controls";
import { WebPageDataService } from "VSS/Contributions/Services";
import * as Diag from "VSS/Diag";
import "VSS/LoaderPlugins/Css!DistributedTaskControls/SharedControls/InputControls/Components/QueryControlInputComponent";
import { getService } from "VSS/Service";
import { ServiceInstanceTypes } from "VSS/WebApi/Constants";

export interface IQueryControlProps extends IInputControlPropsBase<string> {
    value: string;
    onSelectedQueryChanged(value: string): void;
}

export class QueryControlInputComponent extends InputBase<string, IQueryControlProps, IInputControlStateBase<string>> {
    public getType(): string {
        return InputControlType.INPUT_TYPE_QUERY_CONTROL;
    }

    protected getControl(): JSX.Element {
        Diag.logVerbose("[QueryControlInputComponent.getControl]: Method called.");
        return <QueryControlInputComponentBase {...this.props} />;
    }
}

interface IQueryControlState  {
    teamDataLoaded: boolean;
}

class QueryControlInputComponentBase extends Base.Component<IQueryControlProps, IQueryControlState> {
    constructor(props: IQueryControlProps) {
        super(props);

        this.state = {
            teamDataLoaded: false
        };
    }

    public async componentDidMount(): Promise<void> {
        const contribution = {
            id: "ms.vss-dashboards-web.dashboards-team-data-provider",
            properties: {
                serviceInstanceType: ServiceInstanceTypes.TFS
            }
        } as Contribution;
        const dataService = getService(WebPageDataService);
        await dataService.ensureDataProvidersResolved([contribution]);
        this.setState({
            teamDataLoaded: true
        });
    }

    public render(): JSX.Element {
        if (this.state.teamDataLoaded) {
            const options: QueryControl.IQuerySelectorComponentProps = {
                value: this.props.value,
                onValueChanged: this.props.onSelectedQueryChanged,
                label: Resources.QueryText
            } as QueryControl.IQuerySelectorComponentProps;

            return (
                <div className="query-control-input-component">
                    <RequiredIndicator
                        value={this.props.value}
                        onGetErrorMessage={this._getErrorMessage} >
                        <ContributionComponent
                            contribution={QueryControl.QuerySelectorControl.contributionId}
                            initialConfig={options}
                            disabled={this.props.disabled} />
                    </RequiredIndicator>
                </div>
            );
        } else {
            return <span className="bowtie-icon bowtie-spinner" />;
        }
    }

    private _getErrorMessage = () => {
        if (!!this.props.getErrorMessage) {
            return this.props.getErrorMessage(this.props.value);
        }
    }
}
